<div class="notificacoes">
  <app-notificacoes [exibeBotaoVerMais]="true"></app-notificacoes>
</div>